import { createAction } from "@reduxjs/toolkit";
import produce from "immer";
import { Action } from "redux";

import { UserRepresentation } from "../../../api/models/UserRepresentation";
import { AppState } from "../../setup/appRootReducer";

export interface BasicState {
    accessToken?: string,
    currentUser?: UserRepresentation,
    isOrganizationUser?: boolean,
    windowWidth: number,
    organizationsInitialized?: boolean,
    pendingReceivedApplicationsCount?: number,
    endingRepresentations?: boolean,
    endingAuthorizedRepresentations?: boolean
}

const defaultState: BasicState = {
    windowWidth: window.innerWidth
}

export function basicReducer(state: BasicState = defaultState, action: Action) {
    if(setAccessToken.match(action)) {
        state = produce(state, draft => {
            draft.accessToken = action.payload;
        })
    }

    if(setCurrentUser.match(action)) {
        state = produce(state, draft => {
            draft.currentUser = action.payload;
        })
    }

    if(setIsOrganizationUser.match(action)) {
        state = produce(state, draft => {
            draft.isOrganizationUser = action.payload;
        })
    }

    if(setWindowWidth.match(action)) {
        state = produce(state, draft => {
            draft.windowWidth = action.payload;
        })
    }

    if(setOrganizationsInitialized.match(action)) {
        state = produce(state, draft => {
            draft.organizationsInitialized = action.payload;
        })
    }
    if(setPendingReceivedApplicationsCount.match(action)) {
        state = produce(state, draft => {
            draft.pendingReceivedApplicationsCount = action.payload;
        })
    }
    if(setEndingRepresentations.match(action)) {
        state = produce(state, draft => {
            draft.endingRepresentations = action.payload;
        });
    }
    if(setEndingAuthorizedRepresentations.match(action)) {
        state = produce(state, draft => {
            draft.endingAuthorizedRepresentations = action.payload;
        });
    }
    return state;
}

export const setAccessToken = createAction<string | undefined>('setAccessToken');
export const setCurrentUser = createAction<UserRepresentation | undefined>('setCurrentUser');
export const setIsOrganizationUser = createAction<boolean | undefined>('setIsOrganizationUser');
export const setOrganizationsInitialized = createAction<boolean | undefined>('setOrganizationsInitialized');
export const setWindowWidth = createAction<number>('setWindowWidth');
export const setPendingReceivedApplicationsCount = createAction<number | undefined>('setPendingReceivedApplicationsCount');
export const setEndingRepresentations = createAction<boolean | undefined>('setEndingRepresentations');
export const setEndingAuthorizedRepresentations = createAction<boolean | undefined>('setEndingAuthorizedRepresentations');

export function getCurrentUser(state: AppState): UserRepresentation | undefined {
    return state.basic.currentUser;
}

export function getIsOrganizationUser(state: AppState): boolean | undefined {
    return state.basic.isOrganizationUser;
}

export function getOrganizationsInitialized(state: AppState): boolean | undefined {
    return state.basic.organizationsInitialized;
}

export function getWindowWidth(state: AppState): number {
    return state.basic.windowWidth;
}

export function getPendingReceivedApplicationsCount(state: AppState): number | undefined {
    return state.basic.pendingReceivedApplicationsCount;
}

export function getEndingRepresentations(state: AppState): boolean | undefined {
    return state.basic.endingRepresentations;
}

export function getEndingAuthorizedRepresentations(state: AppState): boolean | undefined {
    return state.basic.endingAuthorizedRepresentations;
}

